import React from 'react';
import { Button, Header, Icon, Table, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PermissionsManager from '../PermissionsManager';
import { m } from '../../constants';

const btnAdd = (
  <PermissionsManager hasPermissions={['create_page_builder']}>
    <Button
      as={Link}
      name="new"
      to="/page-builders/new"
      floated="right"
      icon
      labelPosition="left"
      color="blue"
      size="small"
    >
      <Icon name="book" /> Ajouter une page
    </Button>
  </PermissionsManager>
);

const Pages = (props) => {
  if (!props.pages || props.pages.length === 0) {
    return (
      <div>
        <Header as="h1">Page builders</Header>
        <br />
        Aucun enregistrement
        {btnAdd}
      </div>
    );
  }

  return (
    <div>
      <Header as="h1">Page builders</Header>
      <Table selectable singleLine color="red">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Titre</Table.HeaderCell>
            <Table.HeaderCell>Date de création</Table.HeaderCell>
            <Table.HeaderCell>Date de modification</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {props.pages.map((page) => {
            return (
              <Table.Row key={page.id}>
                <Table.Cell>
                  <Link as="a" name="page" to={`page-builders/${page.id}`}>
                    {page.detail.title}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  {m(page.created_at).format('DD/MM/YYYY à HH:mm')}
                </Table.Cell>
                <Table.Cell>
                  {m(page.updated_at).format('DD/MM/YYYY à HH:mm')}
                </Table.Cell>
                <Table.Cell>
                  <Button
                    as={Link}
                    name="page"
                    to={`page-builders/${page.id}`}
                    icon
                    size="small"
                  >
                    <Icon name="pencil" />
                  </Button>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>

        <PermissionsManager hasPermissions={['create_page_builder']}>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="4">
                {btnAdd}
                <Divider hidden={true} />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </PermissionsManager>
      </Table>
    </div>
  );
};

export default Pages;



// WEBPACK FOOTER //
// ./src/components/list/PageBuilders.js